<script>
/**
 * Type   : Page component
 * Title  : 배송상품조회 화면
 * Description : 입력된 고객의 배송 상품 조회화면을 보여주는 화면으로 가장 기본이 되는 화면이다.
 */

import Title from "@/components/admin/common/TitleArea.vue"
import ParcelLookupForm from "@/components/admin/logis/ParcelLookupForm.vue"
import ParcelList from "@/components/admin/logis/list/ParcelList.vue"


export default {
  name: "AdminParcelInfomation",
  meta: {
    title: "어드민-배송상품조회"
  },
  components: {
    Title,
    ParcelLookupForm,
    ParcelList,
  },
  data() {
    return {
      description   : {
        title : '통합조회'
      },
      regId             : this.$store.getters.getLocalSession.id,
      
      receiver          : "",
      mobileCountry     : "",
      mobileNum         : "",
      customerEmail     : "",
      courierCode       : "",
      courierNum        : "",
      customerId        : "",
      orderNum          : "", // 주문번호
      hblNo             : "",
      mblNo             : "",
      statusCode        : [], // 오더 상태 코드 목록
      // filteredLocation  : [],
      shippingMethod    : [],
      proxyDate         : {},
      isDel             : "0",     // 0 : 등록됨, 1 : 삭제됨
      partnerId         : "",

      consoleFilter     : "",     // "", "N", "Y"
      tempConsolStatus  : "",
      packingStatus     : "",

      session           : this.$store.getters.getLocalSession,
      authLevel         : Number(this.$store.getters.getLocalSession.authLevel),
      isRefreshingRecent: false,
      recentPackedLoading: false,
      recentPatchAt     : "",
      parcelLoading: false,
      parcelRequestId: 0,
      activeParcelFilters: null,
      parcelPagination: { page: 1, rowsPerPage: 100, rowsNumber: 0, sortBy: null, descending: true },
    }
  },
  computed: {
    recentPackedOrders() {
      return this.$store.getters.getRecentPackedOrders || []
    },
    recentPackedOrderNos() {
      return this.recentPackedOrders
        .map((item) => item.orderNo)
        .filter(Boolean)
    },
    recentPackedPreview() {
      return this.recentPackedOrders.slice(0, 3)
    },
    hasRecentPackedOrders() {
      return this.recentPackedOrders.length > 0
    }
  },
  methods: {

    /**
     * Title        : 검색영역 동기화
     * Status       : Actived
     * Description  : ParcelLookupForm 컴포넌트 - 검색영역에서 받은 검색조건을 동기화한다.
     * Param (idx)  : 선택된 배송상품의 idx
     */
    lookupOptSync(opt){
      this.$log.debug("[ Parcel info / 검색조건 ]= " , opt)
      
      this.receiver         = opt.receiver
      this.mobileCountry    = opt.mobileCountry
      this.mobileNum        = opt.mobileNum
      this.customerEmail    = opt.customerEmail
      this.courierCode      = opt.courierCode
      this.courierNum       = opt.courierNum
      this.customerId       = opt.customerId
      this.orderNum         = opt.orderNum
      this.hblNo            = opt.hblNo
      this.mblNo            = opt.mblNo
      this.statusCode       = opt.statusCode
      // this.filteredLocation = opt.filteredLocation
      this.shippingMethod   = opt.shippingMethod
      this.proxyDate        = opt.proxyDate
      this.consoleFilter    = opt.consoleFilter
      this.tempConsolStatus = opt.tempConsolStatus
      this.packingStatus    = opt.packingStatus
      this.partnerId        = opt.partnerId
    },

    /**
     * Title        : 검색 조건에 따른 화물검색을 실행
     * Status       : Actived
     * Description  : 검색 조건에 따른 화물검색 기능 실행
     */
    lookupParcel(){
      
      if(!this.validation()){
        return false
      }

      this.loadParcelList()
    },

    /**
     * Title        : 화물조회 실행
     * Status       : Actived
     * Description  : 기본 화물 조회
     */
    buildParcelFilters() {
      const list = (value) => this.quoteList(
        (Array.isArray(value) ? value : String(value || '').split(','))
          .map(item => String(item).trim()).filter(Boolean)
      )
      const filters = {
        receiverName: this.receiver, regId: this.regId, receiverMobile: this.mobileNum,
        email: this.customerEmail, courierCode: this.courierCode, courierNum: this.courierNum,
        customerNum: this.customerId, orderId: list(this.orderNum), hblNo: list(this.hblNo),
        mblNo: list(this.mblNo), status: this.statusCode, freightMethod: this.shippingMethod,
        regDate: this.proxyDate, isDel: this.isDel, partnerId: this.partnerId,
        tempConsolStatus: this.tempConsolStatus, packingStatus: this.packingStatus
      }
      if (this.authLevel >= 90 && this.consoleFilter !== '') {
        filters.consoleId = this.consoleFilter === 'Y'
      }
      return JSON.parse(JSON.stringify(filters))
    },
    async loadParcelList() {
      return this.fetchParcelPage({ ...this.parcelPagination, page: 1 }, this.buildParcelFilters())
    },
    async reloadParcelPage() {
      if (this.activeParcelFilters) return this.fetchParcelPage(this.parcelPagination)
    },
    async requestParcelPage(pagination) {
      if (this.parcelLoading || !this.activeParcelFilters) return
      const changed = pagination.rowsPerPage !== this.parcelPagination.rowsPerPage
        || pagination.sortBy !== this.parcelPagination.sortBy
        || pagination.descending !== this.parcelPagination.descending
      return this.fetchParcelPage({ ...pagination, page: changed ? 1 : pagination.page })
    },
    async fetchParcelPage(pagination, filters = this.activeParcelFilters) {
      if (!filters) return
      const requestId = ++this.parcelRequestId
      const snapshot = JSON.parse(JSON.stringify(filters))
      this.parcelLoading = true
      this.$refs.parcelListCompRef?.clearSelection?.()
      try {
        const res = await this.$http({
          method: 'POST', url: '/api/parcel/parcel',
          data: {
            ...snapshot, includePagination: true, paging: pagination.page - 1,
            pageSize: pagination.rowsPerPage, sortBy: pagination.sortBy,
            descending: pagination.descending
          },
          name: '[ AXIOS / 통합조회 / 페이지 조회 ]'
        })
        if (requestId !== this.parcelRequestId) return
        const data = res.data
        if (!Array.isArray(data?.rows) || !Number.isFinite(Number(data?.pagination?.total))) {
          throw new Error('통합조회 페이지 정보를 확인할 수 없습니다.')
        }
        const result = data.pagination
        if (result.total > 0 && result.page >= result.totalPages) {
          return await this.fetchParcelPage({ ...pagination, page: result.totalPages }, snapshot)
        }
        this.$store.dispatch('loadParcel', data.rows)
        this.activeParcelFilters = snapshot
        this.parcelPagination = {
          ...pagination, page: result.total === 0 ? 1 : result.page + 1,
          rowsPerPage: result.pageSize, rowsNumber: result.total
        }
        this.recentPatchAt = ''
      } catch (err) {
        if (requestId !== this.parcelRequestId) return
        this.$log.error('[ 통합조회 / 페이지 조회 실패 ]', err)
        this.$q.notify({ type: 'negative', message: '목록 조회에 실패했습니다. 다시 조회해 주세요.', position: 'top' })
      } finally {
        if (requestId === this.parcelRequestId) this.parcelLoading = false
      }
    },
    formatDateTime(date = new Date()) {
      const pad = (value) => String(value).padStart(2, "0")
      const year = date.getFullYear()
      const month = pad(date.getMonth() + 1)
      const day = pad(date.getDate())
      const hours = pad(date.getHours())
      const minutes = pad(date.getMinutes())
      const seconds = pad(date.getSeconds())
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    quoteList(values) {
      return values.map((item) => `'${String(item).replace(/'/g, "\\'")}'`)
    },

    getRecentLookupDateRange() {
      if (this.proxyDate?.from && this.proxyDate?.to) return this.proxyDate

      const pad = (value) => String(value).padStart(2, "0")
      const today = new Date()
      const from = new Date()
      from.setMonth(from.getMonth() - 2)

      const format = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
      return {
        from: format(from),
        to: format(today)
      }
    },

    normalizeRecentPackedRows(rows = []) {
      if (!Array.isArray(rows)) return []
      return rows.map((row) => ({
        orderId: row.orderId || null,
        orderNo: row.orderNo || "-",
        hblNo: row.hblNo || "-",
        itemNames: row.itemNames || "-",
        partnerId: row.partnerId || null,
        partnerName: row.partnerName || "-",
        packingStatus: row.packingStatus || "COMPLETED",
        tempConsolStatus: row.tempConsolStatus || "READY",
        packingCompletedAt: row.packingCompletedAt || "",
        tempConsolReadyAt: row.tempConsolReadyAt || "",
        totalQty: Number(row.totalQty || 0),
        totalWeight: Number(row.totalWeight || 0)
      }))
    },

    async loadRecentPackedOrders() {
      if (this.recentPackedLoading) return

      try {
        this.recentPackedLoading = true
        const res = await this.$http({
          method: "POST",
          url: "/api/fulfillment/packing/recent-completed",
          data: {
            hours: 24,
            limit: 30
          },
          name: "[ AXIOS / 통합조회 / 최근 포장완료 조회 ]"
        })
        const rows = this.normalizeRecentPackedRows(res?.data?.data?.rows || [])
        this.$store.dispatch('setRecentPackedOrders', rows)
      } catch (err) {
        this.$log.warn("[ 통합조회 / 최근 포장완료 조회 실패 ]", err)
      } finally {
        this.recentPackedLoading = false
      }
    },

    async refreshRecentPackedRows() {
      const orderNos = this.recentPackedOrderNos
      if (orderNos.length === 0 || this.isRefreshingRecent) return

      const payload = {
        "receiverName"    : "",
        "regId"           : this.regId,
        "receiverMobile"  : "",
        "email"           : "",
        "courierCode"     : "",
        "courierNum"      : "",
        "customerNum"     : "",
        "orderId"         : this.quoteList(orderNos),
        "hblNo"           : [],
        "mblNo"           : [],
        "status"          : [],
        "freightMethod"   : [],
        "regDate"         : this.getRecentLookupDateRange(),
        "isDel"           : this.isDel,
        "partnerId"       : "",
        "tempConsolStatus": "",
        "paging"          : "0",
      }

      try {
        this.isRefreshingRecent = true
        const res = await this.$http({
          method  : "POST",
          url     : "/api/parcel/parcel",
          data    : payload,
          name    : "[ AXIOS / 최근 포장완료 변경건 조회 ]"
        })

        const rows = Array.isArray(res.data) ? res.data : []
        const currentOrderNos = new Set((this.$store.getters.getParcelList || []).map((row) => String(row.orderId)))
        const patchedOrderNos = rows
          .map((row) => String(row.orderId))
          .filter((orderNo) => currentOrderNos.has(orderNo))

        this.$store.dispatch('patchParcelRows', rows)
        this.$store.dispatch('removeRecentPackedOrders', patchedOrderNos)
        this.recentPatchAt = this.formatDateTime()

        this.$q.notify({
          type: patchedOrderNos.length > 0 ? 'positive' : 'warning',
          message: patchedOrderNos.length > 0
            ? `변경 건 ${patchedOrderNos.length}건을 현재 목록에 반영했습니다`
            : '현재 조회 조건에 반영할 변경 건이 없습니다',
          position: 'top',
          timeout: 2500,
        })
      } catch (err) {
        this.$log.error("[ 최근 포장완료 변경건 조회 실패 ]", err)
        this.$q.notify({
          type: 'negative',
          message: '변경 건 조회에 실패했습니다',
          position: 'top',
          timeout: 3000,
        })
      } finally {
        this.isRefreshingRecent = false
      }
    },

    openTempConsolList() {
      this.$refs.parcelListCompRef?.callTempConsolList?.()
    },

    clearRecentPackedNotice() {
      this.$store.dispatch('clearRecentPackedOrders')
      this.recentPatchAt = ""
    },

    /**
     * Title        : 입력값 검증
     * Status       : Actived
     * Description  : 배송상품 입력 시 값을 검증하는 로직
     */
    validation(){
      let a = this.mobileCountry.length
      let b = this.mobileNum.length

      let c = this.courierCode.length
      let d = this.courierNum.length
      this.$log.debug("[ Validation 정보 ]" ,a,b,c,d)

      if(a > 0 || b > 0){
        (a === 0)? alert("국가번호를 선택해주세요.") : ((b === 0) ? alert("모바일 번호를 입력해주세요.") : this.$log.debug("모바일 입력성공"))
      }

      if(c > 0 || d > 0){
        (c === 0)? alert("배송업체를 선택해주세요.") : ((d === 0) ? alert("송장번호를 입력해주세요.") : this.$log.debug("배송상품정보 입력성공"))
      }

      return true
    },

    
    /**
     * Title        : 화물정보 수정 모달 오픈
     * Status       : Actived
     * Description  : 선택된 화물의 idx 를 받아서 수정 모달을 오픈한다.
     * Param (parcelId)  : 선택된 화물의 idx
     */
    modifyParcelInfo(parcelId){
      this.modifyModal = true
      this.selectedParcelId = parcelId
    },

    /**
     * Title        : 화물조회 모드 변경
     * Status       : Actived
     * Description  : ParcelLookupForm 컴포넌트 - 검색영역에서 받은 검색조건을 동기화한다.
     * Param (mode)  : 실행된 모드
     */
    modeChange(){
      
      // 배송상품조회
      // this.isDel = (this.isDel == "0" ? "1" : "0")
      
      this.description.title = (this.isDel == "0" ? "배송상품조회" :  "배송상품조회 - 삭제상품 관리")
      
      this.loadParcelList()
      this.$refs.parcelListCompRef.selectedList = [];

      this.$log.debug("[ 화물조회 모드 변경 ]", this.isDel)
    },

    /**
     * Title        : 페이지 초기화
     * Status       : Actived
     * Description  : 페이지 초기화 기능으로 등록된 화물/삭제된 삭제 모드를 변경시킨다.
     * Param (mode)  : 실행된 모드
     */
    init(){
      if(Number(this.authLevel) >= 90){
        this.$getPartnerList()
      }

      this.loadRecentPackedOrders()

      // 대쉬보드에서 부터 넘어온 경우
      if (this.$route && this.$route.query && this.$route.query?.departure === 'dashboard') {
        const query = this.$route.query;
        if (query.hblNo) this.hblNo = query.hblNo;
        // 필요한 파라미터만 추출해서 데이터에 할당
        // if (query.receiver) this.receiver = query.receiver;
        // if (query.mobileCountry) this.mobileCountry = query.mobileCountry;
        // if (query.mobileNum) this.mobileNum = query.mobileNum;
        // if (query.customerEmail) this.customerEmail = query.customerEmail;
        // if (query.courierCode) this.courierCode = query.courierCode;
        // if (query.courierNum) this.courierNum = query.courierNum;
        // if (query.customerId) this.customerId = query.customerId;
        // if (query.orderNum) this.orderNum = query.orderNum;
        // if (query.mblNo) this.mblNo = query.mblNo;
        // if (query.statusCode) this.statusCode = Array.isArray(query.statusCode) ? query.statusCode : [query.statusCode];
        // if (query.filteredLocation) this.filteredLocation = Array.isArray(query.filteredLocation) ? query.filteredLocation : [query.filteredLocation];
        // if (query.shippingMethod) this.shippingMethod = Array.isArray(query.shippingMethod) ? query.shippingMethod : [query.shippingMethod];
        // if (query.proxyDate) this.proxyDate = JSON.parse(query.proxyDate);
        // 검색 실행
        this.lookupParcel();
      }
    }

  },

  mounted() {
    this.$log.log("[ Parcel info ] mounted")
    
    this.init()
  },
}
</script>


<template>
  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        <Title
          :desc="description">

          <q-toggle
            v-if="Number(session.authLevel) >= 90"
            v-model="isDel"
            true-value="1"
            false-value="0"
            @update:model-value="modeChange()"
            checked-icon="check"
            color="red"
            :label="(isDel == '0' ? '삭제된 상품 관리' : '삭제된 상품 관리 해제')"
            left-label
            unchecked-icon="clear"
          />

        </Title>

      </div>
    </div>

    <div
      v-if="recentPackedLoading || hasRecentPackedOrders || recentPatchAt"
      class="row q-mb-md">
      <div class="col">
        <div class="recent-packed-notice">
          <div class="recent-packed-notice__main">
            <q-icon name="inventory_2" size="28px" color="yellow-9" />
            <div>
              <div class="recent-packed-notice__title">
                포장 화면에서 변경된 건이 있습니다
              </div>
              <div class="recent-packed-notice__caption">
                <template v-if="recentPackedLoading">
                  최근 24시간 포장완료 콘솔대기 건을 확인하는 중입니다.
                </template>
                <template v-else-if="hasRecentPackedOrders">
                  최근 24시간 포장완료 {{ recentPackedOrders.length }}건이 콘솔대기 상태로 반영되었습니다.
                  현재 목록은 이전 조회 결과일 수 있습니다.
                </template>
                <template v-else-if="recentPatchAt">
                  변경 건 반영 완료: {{ recentPatchAt }}. 전체 조건 기준 확인은 배송상품검색을 실행하세요.
                </template>
              </div>
              <div
                v-if="hasRecentPackedOrders"
                class="recent-packed-preview">
                <span
                  v-for="item in recentPackedPreview"
                  :key="item.orderNo"
                  class="recent-packed-preview__item">
                  {{ item.orderNo }} / {{ item.hblNo }}
                </span>
              </div>
            </div>
          </div>
          <div class="recent-packed-notice__actions">
            <q-spinner
              v-if="recentPackedLoading"
              color="primary"
              size="24px" />
            <q-btn
              color="yellow-9"
              text-color="white"
              icon="sync"
              label="변경 건만 조회"
              :loading="isRefreshingRecent"
              :disable="!hasRecentPackedOrders"
              @click="refreshRecentPackedRows" />
            <q-btn
              color="primary"
              outline
              icon="inventory"
              label="임시콘솔 보기"
              @click="openTempConsolList" />
            <q-btn
              color="grey-8"
              outline
              icon="refresh"
              label="전체 재조회"
              @click="lookupParcel" />
            <q-btn
              flat
              color="grey-7"
              icon="close"
              label="닫기"
              @click="clearRecentPackedNotice" />
          </div>
        </div>
      </div>
    </div>

    <div class="row q-mb-sm">
      <!-- <div class="col-12 col-md-12 col-lg-10 q-mb-md"> -->
      <div class="col-12 q-mb-md">
        <ParcelLookupForm
          @lookup-opt-sync="lookupOptSync" 
          @lookup-parcel="lookupParcel"/>
      </div>
      <!--
      <div class="col-12 col-md-12 col-lg-2 q-mb-md">
        <q-btn
          color="primary"
          size="lg"
          label="배송상품검색"
          class="full-width"
          style="height:100%"
          @click="lookupParcel"/>
      </div>
      -->
    </div>
    <div class="row">
      <div class="col">
        
        <div class="comp-box">
          <ParcelList
            ref="parcelListCompRef"
            :is-del="isDel"
            :pagination="parcelPagination"
            :loading="parcelLoading"
            @reload-parcel-list="reloadParcelPage"
            @request-page="requestParcelPage"
          />
        </div>

      </div>
    </div>
  </q-page>

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.recent-packed-notice {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border: 1px solid #eadfbe;
  border-radius: 8px;
  background: #fffaf0;
}

.recent-packed-notice__main {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.recent-packed-notice__title {
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 700;
}

.recent-packed-notice__caption {
  margin-top: 3px;
  color: #667085;
  font-size: 13px;
}

.recent-packed-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.recent-packed-preview__item {
  padding: 4px 8px;
  border: 1px solid #eadfbe;
  border-radius: 6px;
  background: #fff;
  color: #394b59;
  font-size: 12px;
}

.recent-packed-notice__actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
}

@media (max-width: 1023px) {
  .recent-packed-notice {
    flex-direction: column;
  }

  .recent-packed-notice__actions {
    width: 100%;
    flex-wrap: wrap;
  }
}
</style>
